import styles from './template.css';
import {template} from './template';
import {AoflElement, customElement} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';

/**
 * @summary ParentLayout
 * @extends {AoflElement}
 */
@customElement('parent-layout')
class ParentLayout extends i18nMixin(AoflElement) {
  /**
   * Creates an instance of ParentLayout.
   */
  constructor() {
    super();
  }

  /**
   * @readonly
   */
  static is = 'parent-layout';

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }
}

export default ParentLayout;
